import { CoreUiException } from "./core-ui-exception";

/**
 * Occurrs when the EnvironmentConfiguration is malformed.
 *
 */
export class ConfigurationException extends CoreUiException {

    constructor(message: string, originalError?: any) {

        super("ConfigurationException", message, originalError);

        // Work around for Error Extension
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, ConfigurationException.prototype);
    }
}
